<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>ID</th>
            <th>{{ $t('common.first_name') }}</th>
            <th>{{ $t('components.subscription.start_date') }}</th>
            <th>{{ $t('components.subscription.expiring_date') }}</th>
            <th>{{ $t('common.state') }}</th>
            <th>{{ $t('components.subscription.residual_appointments') }}</th>
        </tr>
        </thead>
        <tbody>
        <SubscriptionRow
            :subscription="subscription"
            v-for="subscription in subscriptions"
            v-bind:key="subscription.id"
        ></SubscriptionRow>
        </tbody>
    </table>
</template>

<script>
import SubscriptionRow from "@/components/subscription/SubscriptionRow";

export default {
    name: "SubscriptionsTable",
    components: {SubscriptionRow},
    props: {
        subscriptions: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>